const RAMP_CSS = {
  iron: "linear-gradient(to right, rgb(0,0,60), rgb(40,40,120), rgb(200,120,40), rgb(230,60,30), rgb(255,240,200))",
  clay: "linear-gradient(to right, rgb(20,20,60), rgb(30,120,140), rgb(120,200,120), rgb(230,200,90), rgb(250,250,210))",
  soil: "linear-gradient(to right, rgb(30,40,30), rgb(90,80,40), rgb(160,130,70), rgb(210,180,120), rgb(245,230,190))",
  vegetation: "linear-gradient(to right, rgb(120,60,20), rgb(200,180,60), rgb(120,190,60), rgb(30,130,40), rgb(10,70,20))",
  water: "linear-gradient(to right, rgb(10,20,40), rgb(20,70,130), rgb(40,130,200), rgb(120,190,230), rgb(220,240,255))",
  anomaly: "linear-gradient(to right, rgb(10,20,60), rgb(40,120,140), rgb(250,220,90), rgb(240,120,40), rgb(200,20,30))",
  prospectivity: "linear-gradient(to right, rgb(20,40,80), rgb(40,140,150), rgb(230,210,100), rgb(235,130,50), rgb(200,20,40))",
  diverging: "linear-gradient(to right, rgb(30,60,150), rgb(90,150,210), rgb(245,245,245), rgb(230,140,90), rgb(200,30,40))",
  gray: "linear-gradient(to right, #111, #eee)",
};

const INDEX_RAMP = {
  iron_oxide: "iron", ferrous_iron: "iron", clay_hydroxyl: "clay", bare_soil: "soil",
  ndvi: "vegetation", ndwi: "water", mineral_anomaly: "anomaly",
};

function resolve(key, profile) {
  if (!key) return null;
  const prosp = ["prospectivity", "prospectivity_ml", "prospectivity_unsup", "prospectivity_blended"];
  if (prosp.includes(key)) {
    return { ramp: profile?.legend_ramp || "prospectivity", label: profile?.legend_label || `${profile?.label || ""} prospectivity`.trim() };
  }
  if (INDEX_RAMP[key]) return { ramp: INDEX_RAMP[key], label: key.replace(/_/g, " ") };
  if (key.startsWith("terrain:")) {
    const k = key.split(":")[1];
    const map = { elevation: "soil", slope: "iron", aspect: "anomaly", hillshade: "gray", drainage: "water" };
    return { ramp: map[k] || "anomaly", label: `Terrain - ${k}` };
  }
  if (key.startsWith("structure:")) {
    const k = key.split(":")[1];
    const map = { density: "anomaly", intersection: "iron", combined: "prospectivity" };
    return { ramp: map[k] || "anomaly", label: `Structure - ${k} density` };
  }
  if (key.startsWith("lineaments")) return { ramp: "anomaly", label: "Lineament density" };
  if (key.startsWith("pca")) return { ramp: "anomaly", label: "PCA component" };
  if (key.startsWith("sar")) return { ramp: "gray", label: "SAR backscatter (VV)" };
  if (key.startsWith("aux:")) return { ramp: "anomaly", label: key.slice(4) };
  return { ramp: "anomaly", label: key.replace(/_/g, " ") };
}

export default function MapLegend({ overlay, profile }) {
  const base = resolve(overlay?.key, profile);
  if (!base) return null;
  const ramp = overlay?.ramp || base.ramp;
  const label = overlay?.label || base.label;
  const diverging = ramp === "diverging";
  return (
    <div className="absolute bottom-3 left-3 z-[800] bg-card/95 border border-border rounded-md p-2.5 shadow-lg w-56" data-testid="map-legend">
      <p className="overline mb-1 truncate" title={label}>{label}</p>
      <div className="h-3 rounded" style={{ background: RAMP_CSS[ramp] || RAMP_CSS.anomaly }} />
      <div className="flex justify-between text-[10px] font-mono text-muted-foreground mt-0.5">
        <span>{diverging ? "Low (−)" : "Low"}</span>{diverging && <span>0</span>}<span>{diverging ? "High (+)" : "High"}</span>
      </div>
    </div>
  );
}
